var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDef(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 20.7165C12.5309 20.9016 11.7769 21 11 21C6.02944 21 2 16.9706 2 12C2 7.02944 6.02944 3 11 3C15.5896 3 19.3768 6.4354 19.9304 10.875M3.125 15.375H5.75C6.78554 15.375 7.625 14.5355 7.625 13.5V11.0625C7.625 10.027 8.46447 9.1875 9.5 9.1875H11.375C12.4105 9.1875 13.25 8.34804 13.25 7.3125V4.125M18.9196 17.6457L21.496 16.755C21.9789 16.588 21.9951 15.911 21.5207 15.7212L15.133 13.1657C14.6887 12.988 14.2442 13.4215 14.4108 13.8702L16.8441 20.4217C17.0219 20.9005 17.6987 20.9015 17.878 20.4233L18.9196 17.6457Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDef);
export default __webpack_public_path__ + "static/media/def.29c4847e965947a463f6bc5b57a1d808.svg";
export { ForwardRef as ReactComponent };